import { Set as ImmutableSet } from 'immutable';
import RequestStatusTypes from '../constants/RequestStatusTypes';
const FINISHED_STATUSES = ImmutableSet([RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED]);
export const allFinishedWithSuccess = (...requestStatuses) => {
  return requestStatuses.every(requestStatus => requestStatus === RequestStatusTypes.SUCCEEDED);
};
export const anyRequestsFailed = (...requestStatuses) => {
  return requestStatuses.includes(RequestStatusTypes.FAILED) || requestStatuses.some(status => status.endsWith('FAILURE'));
};
export const allRequestsInitiated = (...requestStatuses) => {
  return requestStatuses.every(requestStatus => requestStatus !== undefined && requestStatus !== RequestStatusTypes.UNINITIALIZED);
};
export const anyRequestsPending = (...requestStatuses) => {
  return requestStatuses.includes(RequestStatusTypes.PENDING);
};
export const allFinished = (...requestStatuses) => requestStatuses.every(requestStatus => FINISHED_STATUSES.contains(requestStatus));